import React, { createContext, Dispatch, PropsWithChildren, SetStateAction, useState } from 'react';
import { Window } from '../../components/window/Window';
import { Body } from './partials/Body';
import { Footer } from './partials/Footer';
import { Header } from './partials/Header';

export const Provider = ({
    children, close, fullHeight, fullWidth,
    providerStack: ProviderStack = DefaultProviderStack,
    bodyContainer: BodyContainer = DefaultBodyContainer
}: Props) => {
    const [WindowContext, setWindowContext] = useState<WindowContext>(initialState);
    return (
        <WindowRendererContext.Provider value={{ windowContext: WindowContext, setWindowContext }}>
            <ProviderStack deps={[WindowContext]}>
                {isInitialized(WindowContext) && (
                    <Window close={close} fullHeight={fullHeight} fullWidth={fullWidth}>
                        {WindowContext.Header}
                        <BodyContainer>
                            {WindowContext.Body}
                        </BodyContainer>
                        {WindowContext.Footer}
                    </Window>
                )}
                {children}
            </ProviderStack>
        </WindowRendererContext.Provider>
    );
};

const isInitialized = (context: WindowContext) => {
    return context.Header !== null
        && context.Body !== null
        && context.Footer !== null;
};

const initialState: WindowContext = {
    Header: null,
    Body: null,
    Footer: null
};

export const WindowRendererContext = createContext<{
    windowContext: WindowContext;
    setWindowContext: SetWindowContext;
}>({
    windowContext: initialState,
    setWindowContext: () => {}
});

type SetWindowContext = Dispatch<SetStateAction<WindowContext>>;

export type WindowContext = {
    Header: ReturnType<typeof Header> | null;
    Body: ReturnType<typeof Body> | null;
    Footer: ReturnType<typeof Footer> | null;
};

type Props = PropsWithChildren<{
    close: () => void;
    fullHeight?: boolean;
    fullWidth?: boolean;
    bodyContainer?: BodyContainer;
    providerStack?: ProviderStack;
}>;

type BodyContainer = (props: PropsWithChildren<Record<never, never>>) => JSX.Element;
const DefaultBodyContainer: BodyContainer = ({ children }) => <>{children}</>;

type ProviderStack = (props: PropsWithChildren<{ deps: any[] }>) => JSX.Element;
const DefaultProviderStack: ProviderStack = ({ children }) => <>{children}</>;